import { createStyles } from '@mantine/styles';

var useStyles = createStyles(() => ({
  root: {}
}));

export default useStyles;
//# sourceMappingURL=Timeline.styles.js.map
